export default "__VITE_ASSET__BMRPX78f__"